import camel from 'lodash/camelCase'

let requireModule = require.context('./modules', true, /^((?!\.unit\.).)*\.js$/)
let root = { modules: {} }

requireModule.keys().forEach(fileName => {
  let modulePath = fileName
    .replace(/^\.\//, '')
    .replace(/\.\w+$/, '')
    .split(/\//)
    .map(camel)

  let getNamespace = (subtree, path) => {
    if (path.length === 1) return subtree
    let namespace = path.shift()
    subtree.modules[namespace] = { modules: {}, ...subtree.modules[namespace] }
    return getNamespace(subtree.modules[namespace], path)
  }

  let { modules } = getNamespace(root, modulePath)

  modules[modulePath.pop()] = {
    namespaced: true,
    ...requireModule(fileName),
  }
})

export let modules = root.modules